import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllIR8AForms = async ({
  companyCode,
  employeeCode,
  isApproved = null,
  isSubmission = null,
  year,
}) => {
  if (!companyCode) {
    throw new Error("Company code is required");
  }
  let queryString = `?CompanyCode=${companyCode}`;
  if (employeeCode) {
    queryString += `&EmployeeCode=${employeeCode}`;
  }

  if (isApproved !== null) {
    queryString += `&Approved=${isApproved}`;
  }
  if (isSubmission !== null) {
    queryString += `&Submission=${isSubmission}`;
  }
  if (year) {
    queryString += `&Year=${year}`;
  }

  const { data } = await http_payroll.get(`${Api_EndPoints.GetAllIR8AForms}${queryString}`);
  return data;
};

export const useGetAllIR8AFormsQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetAllIR8AForms],
    queryFn: () => getAllIR8AForms(input),
  });
};
